import React, { useEffect, useState } from "react";
import CustomerLayout from "../../../layouts/CustomerLayout";
import Summary from "../../../components/home/Summary";
import RecentBulkMessages from "../../../components/home/RecentBulkMessages";
import dashboardRequests from "../../../api/Customer/DashboardRequests";
import Loader from "../../../components/utilities/Loader";
import subscriptionRequests from "../../../api/Customer/SubscriptionRequests";
import { setUser, updateSubscriptionData } from "../../../redux/userSlice";
import { useDispatch, useSelector } from "react-redux";
import InactiveAccountModal from "../../../components/InactiveAccountModal";

const Home = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userStats, setUserStats] = useState(null);
  const [showInactiveModal, setShowInactiveModal] = useState(false);
  const user = useSelector((state) => state.user?.txtconnect_ng_user);
  const [currentUserSubscriptionData, setCurrentUserSubscriptionData] = useState(null);
  const dispatch = useDispatch();
  const fetchDashboardData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const [userStatsResponse, currentUserSubscriptionDataResponse] =
          await Promise.all([
            dashboardRequests.getUserStats(),
            subscriptionRequests.getCurrentUserSubscriptionData(),
          ]);

        console.log("userStatsResponse:", userStatsResponse);
        console.log("currentUserSubscriptionDataResponse:", currentUserSubscriptionDataResponse);

        // Check for inactive account in userStatsResponse
        if (userStatsResponse.data?.status_code === 403 ||
            userStatsResponse.message?.toLowerCase().includes("inactive")) {
          setShowInactiveModal(true);
          setIsLoading(false);
          return;
        }

        if (userStatsResponse.data.status_code === "000") {
          setUserStats(userStatsResponse.data.data);
        }

        // Check for inactive account in subscription response
        if (currentUserSubscriptionDataResponse?.status_code === 403 && 
            currentUserSubscriptionDataResponse?.reason?.toLowerCase().includes("inactive")) {
          setShowInactiveModal(true);
          setIsLoading(false);
          return;
        }

        if (currentUserSubscriptionDataResponse.status_code === "000") {
          const subscriptionData = currentUserSubscriptionDataResponse.data;
          setCurrentUserSubscriptionData(subscriptionData);

          if (
            subscriptionData.subscription_plan &&
            subscriptionData.subscription_plan.status &&
            subscriptionData.subscription_plan.status.toLowerCase() === "paid"
          ) {
            dispatch(
              setUser({
                userData: {
                  ...user,
                  units: subscriptionData.units,
                },
                token: user?.token || null,
              })
            );
            dispatch(
              updateSubscriptionData({
                subscriptionData: subscriptionData.subscription_plan,
                plan_name: subscriptionData.plan_name,
                units: subscriptionData.units,
              })
            );
          }
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
        
        // Check if error response indicates inactive account
        if (error?.response?.data?.status_code === 403 && 
            error?.response?.data?.reason?.toLowerCase().includes("inactive")) {
          setShowInactiveModal(true);
        } else {
          setError("Failed to load dashboard data. Please try again.");
        }
      } finally {
        setIsLoading(false);
      }
    };
  useEffect(() => {
  

    fetchDashboardData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return (
      <CustomerLayout>
        <div className="flex justify-center items-center min-h-screen">
          <div className="text-center">
            <p className="mb-4 text-red-600">{error}</p>
            <button
              onClick={fetchDashboardData}
              className="px-4 py-2 text-white bg-red-600 rounded hover:bg-red-700"
            >
              Retry
            </button>
          </div>
        </div>
      </CustomerLayout>
    );
  }

  return (
  <>
    <CustomerLayout>
      <Summary
        userStats={userStats}
        currentUserSubscriptionData={currentUserSubscriptionData}
      />
      {/* ✅ Only render when data exists */}
      {userStats && <RecentBulkMessages userStats={userStats} />}
    </CustomerLayout>

    {showInactiveModal && <InactiveAccountModal />}
  </>
);
};

export default Home;